<template lang="pug">
	.dynamic-container-v3
		.tab-container
			.tab(:class="{'active': activeTab == index}" v-for="(tab, index) in tabs" @click="setActiveTab(index)" @set-active-tab="setActiveTab")
				| {{tab}}

		.dynamic-content-v3(v-for="(tab, index) in tabs" :class="{'d-block': activeTab == index, 'd-none': activeTab != index}")
			slot(:name="index")
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.dynamic-container-v3
	.dynamic-content-v3
		text-align left
		>>> .input-item
			max-width 300px
		>>> .sfc-button
			margin-top 80px
	.tab-container
		display block
		width 100%
		border-bottom 3px solid sfc-pale-gray-light
		position relative
		text-align left
		margin-bottom 40px
		.tab
			cursor pointer
			position relative
			top 3px
			text-align left
			cursor: pointer
			padding-bottom: 10px
			padding-left: 20px
			padding-right: 20px
			&:hover
				color: sfc-royal-blue
			&.active
				color: sfc-royal-blue
				border-bottom: 3px solid sfc-royal-blue
			display: inline-block
			@media(max-width: 991px)
				padding-bottom: 20px
			&:first-child
				margin-left: 0

</style>

<script>

export default {
	props: {
		tabs:{
		}
	},

	components:{
	},

	data() {
		return {
			activeTab: 0,
		}
	},

	computed: {
	},

	mounted(){

	},

	methods: {
		setActiveTab(index){
			this.activeTab = index
		}
	}
}
</script>
